class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.id;
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.content = this.summaryToggle?.nextElementSibling;
    this.mql = window.matchMedia('(min-width: 750px)');
    this.countrySelect = {
      el: this.querySelector('[name="address[country]"]'),
      select: null,
    }
    this.provinceSelect = {
      el: this.querySelector('[name="address[province]"]'),
      select: null,
    }

    if (!this.detailsContainer) return;

    this.handleKeyUp = this.onKeyUp.bind(this);
    this.handleSummaryClick = this.onSummaryClick.bind(this);
    this.handleClose = this.close.bind(this);
    this.handleOpenAttributes = this.updateAttributes.bind(this, true);
    this.handleCloseAttributes = this.updateAttributes.bind(this, false);
    this.handleMediaQueryChange = this.buildTimeline.bind(this);
    this.summaryToggle.setAttribute('role', 'button');
  }

  connectedCallback() {
    this.buildTimeline();
    this.detailsContainer.addEventListener('keyup', this.handleKeyUp);
    this.summaryToggle.addEventListener('click', this.handleSummaryClick);
    this.mql.addEventListener('change', this.handleMediaQueryChange);
    this.querySelectorAll('[data-modal-close]').forEach(button => {
      button.addEventListener('click', this.handleClose);
    });
  }

  disconnectedCallback() {
    this.timeline?.kill();
    this.detailsContainer.removeEventListener('keyup', this.handleKeyUp);
    this.summaryToggle.removeEventListener('click', this.handleSummaryClick);
    this.mql.removeEventListener('change', this.handleMediaQueryChange);
    this.querySelectorAll('[data-modal-close]').forEach(button => {
      button.removeEventListener('click', this.handleClose);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.close();
  }

  buildTimeline() {
    if (!this.content) return;

    if (this.timeline) this.timeline.kill();

    this.timeline = gsap.timeline({
      paused: true,
      onStart: this.handleOpenAttributes,
      onReverseComplete: this.handleCloseAttributes,
    }).from(this.content, {
      scale: 0.7,
      autoAlpha: 0,
      duration: 0.2,
      ease: 'power1.inOut',
      onComplete: () => {
        if (this.countrySelect.select) {
          this.countrySelect.select?.update();
          this.provinceSelect.select?.update();
        }
      }
    });

    if (this.isOpen()) {
      this.timeline.progress(1);
    }
  }

  updateAttributes(open = true) {
    this.detailsContainer.classList.toggle('is-open', open);
    document.body.classList.toggle('overflow-hidden', open);
    document.body.classList.toggle('has-open-modal', open);
    this.detailsContainer.toggleAttribute('open', open);
    this.summaryToggle.setAttribute('aria-expanded', open);

    if (this.id) {
      document.body.classList.toggle(`has-open-modal--${this.id}`, open);
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.timeline.play();
    document.body.addEventListener('click', this.onBodyClickEvent);

    event.target.closest('details').querySelectorAll('select').forEach(select => {
      if (select.style.display !== 'none') {
        const labelEl = document.querySelector(`label[for="${select.id}"]`);
        const label = labelEl ? labelEl.textContent.trim() : null;

        const fancySelect = Select.bind(select, { placeholder: label });
        labelEl.classList.add('visually-hidden');

        if (select.name === 'address[country]') {
          this.countrySelect.select = fancySelect;
        }

        if (select.name === 'address[province]') {
          this.provinceSelect.select = fancySelect;
        }
      }
    });

    if (this.countrySelect.el) {
      this.countrySelect.el.addEventListener('change', () => {
        this.updateProvinceSelect();
      });
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.classList.remove('is-open');
    this.timeline.reverse();
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }

  updateProvinceSelect() {
    this.provinceSelect.select.update();
  }
}

customElements.define('details-modal', DetailsModal);

class SearchModal extends DetailsModal {
  constructor() {
    super();
  }

  buildTimeline() {
    if (!this.content) return;

    if (this.timeline) this.timeline.kill();

    this.timeline = gsap.timeline({
      paused: true,
      onStart: this.handleOpenAttributes,
      onReverseComplete: this.handleCloseAttributes,
    }).fromTo(this.content, {
      yPercent: -20,
      autoAlpha: 0,
    }, {
      yPercent: 0,
      autoAlpha: 1,
      duration: 0.2,
      ease: 'power1.inOut',
    });

    if (this.isOpen()) {
      this.timeline.progress(1);
    }
  }

  open(event) {
    super.open(event);
    setTimeout(() => this.querySelector('input[type="search"]')?.focus(), 200);
  }
}

customElements.define('search-modal', SearchModal);